<div class="pdf-page app-aul-027-24" id="aul02724">
  <!-- <app-policy-header></app-policy-header>-->
  <p class="font-large" style="text-align: center">
    <b> ASBESTOS ENDORSEMENT </b>
  </p>
  <p class="font-medium">
    <b> THIS ENDORSEMENT CHANGES THE POLICY. PLEASE READ CAREFULLY.</b>
  </p>
  <div class="font-small">
    <ol>
      <li>
        This Policy only insures asbestos physically incorporated in an insured
        building or structure, and then only that part of the asbestos which has
        been physically damaged during the period of insurance by one of these
        Listed Perils: <br />
        <p class="ps-10">
          fire; explosion; lightning; windstorm; hail; direct impact of vehicle,
          aircraft or vessel; riot or civil commotion, vandalism or malicious
          mischief; or accidental discharge of fire protective equipment.
        </p>
      </li>   
 
  <p class="font-small">
    This coverage is subject to each of the following specific limitations:
  </p>

  <!-- <div class="font-small"> -->
    <ol class="ps-20">
      <li style="padding-bottom: 10px;">
        The said building or structure must be insured under this Policy for
        damage by that Listed Peril.
      </li>
      <li style="padding-bottom: 10px;">
        The Listed Peril must be the immediate, sole cause of the damage of the
        asbestos.
      </li>
      <li style="padding-bottom: 10px;">
        You must report to Us the existence and cost of the damage as soon as
        practicable after the Listed Peril first damaged the asbestos. However,
        this Policy does not insure any such damage first reported to Us more
        than 12 (twelve) months after the expiration, or termination, of the
        period of insurance.
      </li>
      <li style="padding-bottom: 10px;">
        Insurance under this Policy in respect of asbestos shall not include any
        sum relating to:

        <ol type="i">
          <li style="padding-bottom: 10px; padding-top: 10px;">
            any faults in the design, manufacture or installation of the
            asbestos;
          </li>
          <li style="padding-bottom: 10px;">
            asbestos not physically damaged by the Listed Peril including any
            governmental or regulatory authority direction or request of
            whatsoever nature relating to undamaged asbestos.
          </li>
        </ol>
      </li>
    </ol>
  <!-- </div> -->
  <!-- <div class="font-small"> -->
   
      <li>
        Except as set forth in the foregoing Section A, this Policy does not
        insure asbestos or any sum relating thereto.
      </li>
    </ol>
     </div>
  <!-- </div> -->
</div>
